/**
 * klubb-product-showcase — horizontal scroll-snap carousel.
 *
 * Each [data-klubb-showcase] block contains:
 *   [data-klubb-showcase-rail]  the scrolling row
 *   [data-klubb-showcase-prev]  optional prev arrow button
 *   [data-klubb-showcase-next]  optional next arrow button
 *
 * Arrows scroll the rail by one viewport width and hide themselves
 * when at the start/end of the rail. If the rail isn't scrollable
 * (content fits entirely), both arrows hide.
 */

export function wireShowcase(scope) {
  if (!scope || scope.dataset.klubbShowcaseWired === 'true') return;
  scope.dataset.klubbShowcaseWired = 'true';

  const rail = scope.querySelector('[data-klubb-showcase-rail]');
  const prev = scope.querySelector('[data-klubb-showcase-prev]');
  const next = scope.querySelector('[data-klubb-showcase-next]');
  if (!rail) return;

  function update() {
    const max = rail.scrollWidth - rail.clientWidth;
    const scrollable = max > 1;
    const atStart = rail.scrollLeft <= 1;
    const atEnd = rail.scrollLeft >= max - 1;

    if (prev) prev.toggleAttribute('hidden', !scrollable || atStart);
    if (next) next.toggleAttribute('hidden', !scrollable || atEnd);
  }

  if (next) {
    next.addEventListener('click', () => {
      rail.scrollBy({ left: rail.clientWidth, behavior: 'smooth' });
    });
  }
  if (prev) {
    prev.addEventListener('click', () => {
      rail.scrollBy({ left: -rail.clientWidth, behavior: 'smooth' });
    });
  }

  rail.addEventListener('scroll', update, { passive: true });
  if (typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(update);
    ro.observe(rail);
  } else {
    window.addEventListener('resize', update);
  }
  update();
}

function init() {
  document.querySelectorAll('[data-klubb-showcase]').forEach(wireShowcase);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
